var app = app || {
            notify: {
                info: function (message) {
                    return swal(message);
                },
                error: function (message) {
                    return swal("", message, "error");
                },
                success: function (message) {
                    return swal("Ok", message, "success");
                }
            }
        };